import React from 'react';

import { Box, FormControlLabel } from '@material-ui/core';

import { AppCheckbox } from '@vyce/core/src/components/inputs';

import useStyles from '../../styles';

export interface TargetGridItem {
  id: string;
  name: string;
  disabled?: boolean;
  /** Short reason shown next to a disabled item, e.g. "no shifts" */
  hint?: string;
}

interface Props {
  items: TargetGridItem[];
  selectedIds: string[];
  onToggle: (id: string, checked: boolean) => void;
  /** Adds a leading "all" checkbox when there is more than one enabled item */
  allLabel?: string;
  onToggleAll?: (checked: boolean) => void;
}

const itemStyle = { marginRight: '24px', marginTop: '4px' };

export const TargetCheckboxGrid: React.FC<Props> = ({
  items,
  selectedIds,
  onToggle,
  allLabel,
  onToggleAll,
}) => {
  const classes = useStyles();
  const enabledItems = items.filter(item => !item.disabled);
  const allChecked = enabledItems.length > 0 && enabledItems.every(item => selectedIds.includes(item.id));

  return (
    <Box marginLeft="-6px" display="flex" flexWrap="wrap">
      {onToggleAll && enabledItems.length > 1 && (
        <FormControlLabel
          classes={{ label: classes.detailsTitle }}
          style={itemStyle}
          control={
            <AppCheckbox
              checked={allChecked}
              onChange={event => onToggleAll(event.target.checked)}
              variant="rectangle"
              color="primary"
            />
          }
          label={allLabel ?? 'All'}
        />
      )}

      {items.map(item => (
        <FormControlLabel
          key={item.id}
          classes={{ label: classes.detailsTitle }}
          style={itemStyle}
          control={
            <AppCheckbox
              checked={selectedIds.includes(item.id)}
              disabled={item.disabled}
              onChange={event => onToggle(item.id, event.target.checked)}
              variant="rectangle"
              color="primary"
            />
          }
          label={
            item.hint ? (
              <span>
                {item.name} <span className={classes.hint}>· {item.hint}</span>
              </span>
            ) : (
              item.name
            )
          }
        />
      ))}
    </Box>
  );
};
